import * as condition from 'ol/events/condition'
import Interaction from 'ol/interaction/Interaction'
/**
 * Identify interaction class
 *
 * @param {Object} opt_options
 * @constructor
 */
export default class Text extends Interaction {
  constructor(options) {
    options = options || {}

    options.handleEvent = e => this._handleEvent(e)

    super(options)

    this.text = options.text

    this.enableToggle = true
  }

  /**
   * Handle map events and delegate clicks to text tool
   * @param {Object} e
   * @return {boolean}
   */
  _handleEvent(e) {
    if (condition.singleClick(e) || condition.click(e)) {
      this.text.handleMapClick(e)
    }
    return true
  }
}
